import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_BYTES = 200 * 1024 * 1024;

const labelFor = (id) => (id === "graduation" ? "the graduation video" : `module ${id.slice(1)}`);

// Admin-side module video slots: which ids have a video, plus upload / remove actions.
export const useModuleVideos = () => {
  const [available, setAvailable] = useState(new Set());
  const [uploadingId, setUploadingId] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/modules/videos/index`)
      .then((r) => { if (alive) setAvailable(new Set(r.data?.available || [])); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const upload = async (id, file) => {
    if (!file) return;
    if (file.size > MAX_BYTES) { toast.error("Video is larger than 200 MB."); return; }
    setUploadingId(id);
    const form = new FormData();
    form.append("file", file);
    try {
      await axios.post(`${API}/admin/modules/${id}/video`, form, { headers: { "Content-Type": "multipart/form-data" } });
      setAvailable((prev) => new Set(prev).add(id));
      toast.success(id === "graduation" ? "Graduation video uploaded." : `Module ${id.slice(1)} video uploaded.`);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Upload failed.");
    } finally {
      setUploadingId(null);
    }
  };

  const remove = async (id) => {
    if (!window.confirm(`Remove the current video for ${labelFor(id)}?`)) return;
    try {
      await axios.delete(`${API}/admin/modules/${id}/video`);
      setAvailable((prev) => { const s = new Set(prev); s.delete(id); return s; });
      toast.success("Video removed.");
    } catch {
      toast.error("Could not remove video.");
    }
  };

  return { available, uploadingId, upload, remove };
};
